import { Box, styled } from '@mui/material';
import { LwFormInput } from 'redesign';
import { FormProvider, useForm } from 'react-hook-form';
import { WaitNodeEditorProps, WaitNodeFormValues } from './wait-node.types';
import { SidebarFooter } from '../../../../sidebar-footer';

export const WaitNodeEditor = ({ node, onSave, onClose }: WaitNodeEditorProps) => {
  const source = (node.data ?? {}) as Partial<WaitNodeFormValues>;

  const form = useForm<WaitNodeFormValues>({
    defaultValues: {
      percentage: source.percentage,
    },
  });

  const submit = form.handleSubmit((values) => {
    onSave({
      ...(node.data ?? {}),
      percentage: Number(values.percentage),
    });
    onClose();
  });

  return (
    <FormProvider {...form}>
      <Box display="flex" flexDirection="column" gap={2} height="100%">
        <ConrentWrapper>
          <Title>Timed Delay</Title>
          <LwFormInput
            name="percentage"
            inputType="number"
            control={form.control}
            label={'Percentage of time before job starts'}
            helperText={
              'Example: 90% with a shift created at 10:20 starting at 10:30  execution continues at 10:21.'
            }
            rules={{
              required: true,
              min: {
                value: 0,
                message: 'Percentage must be between 0 and 100.',
              },
              max: {
                value: 100,
                message: 'Percentage must be between 0 and 100.',
              },
            }}
          />
        </ConrentWrapper>
        <SidebarFooter onClose={onClose} submit={submit} />
      </Box>
    </FormProvider>
  );
};

const ConrentWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  flex: 1,
  overflowY: 'auto',
  padding: '12px 4px',
});
const Title = styled(Box)({
  fontWeight: 700,
  fontSize: 18,
  textAlign: 'center',
  marginBottom: 12,
  marginTop: 12,
});
